import { render, staticRenderFns } from "./AutobuyerBox.vue?vue&type=template&id=9b85a9f2&scoped=true"
import script from "./AutobuyerBox.vue?vue&type=script&lang=js"
export * from "./AutobuyerBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b85a9f2",
  null
  
)

export default component.exports